module.exports = __webpack_public_path__ + "static/media/Icons_Public_Document_Centre_Intake_Areas.e829bb04.png";